import { TermKey } from "@/_services/terminology/catalog";
import {
    GlobalSearchGroup,
    GlobalSearchResult,
} from "@/_models/global-search.model";

export interface GlobalSearchResultRow extends GlobalSearchResult {
    route: string[];
    position: number;
    optionId: string;
}

export interface GlobalSearchResultSection {
    labelKey: TermKey;
    rows: GlobalSearchResultRow[];
}

interface GlobalSearchRecordType {
    labelKey: TermKey;
    routeTo: (result: GlobalSearchResult) => string[];
}

const routeById =
    (prefix: string) =>
    ({ id }: GlobalSearchResult): string[] => [prefix, id];

const RECORD_TYPES: Readonly<Record<string, GlobalSearchRecordType>> = {
    Flight: {
        labelKey: "dashboard.module.reports",
        routeTo: ({ id, publicId }) => ["/reports-v2", publicId || id],
    },
    Hazard: {
        labelKey: "dashboard.module.hazardRegister",
        routeTo: routeById("/risk-management/hazard-register"),
    },
    Control: {
        labelKey: "control.library",
        routeTo: routeById("/risk-management/control-library"),
    },
    RiskEvaluation: {
        labelKey: "riskEval.plural",
        routeTo: routeById("/risk-management/evaluations"),
    },
    Issue: {
        labelKey: "dashboard.module.safetyCases",
        routeTo: routeById("/assurance/registry"),
    },
    Audit: {
        labelKey: "dashboard.module.internalAudits",
        routeTo: routeById("/assurance/internal-audit"),
    },
    Inspection: {
        labelKey: "dashboard.module.inspections",
        routeTo: routeById("/assurance/inspections"),
    },
    Meeting: {
        labelKey: "dashboard.module.meetings",
        routeTo: routeById("/promotions/meeting-minutes"),
    },
    Task: {
        labelKey: "dashboard.module.actions",
        routeTo: routeById("/home/tasks"),
    },
    Promotion: {
        labelKey: "dashboard.module.promotions",
        routeTo: routeById("/promotions"),
    },
    PolicyObjective: {
        labelKey: "dashboard.module.safetyObjectives",
        routeTo: routeById("/policies/objectives"),
    },
};

export const RESULTS_LIST_ID = "global-search-results";

export function toResultSections(
    groups: GlobalSearchGroup[],
): GlobalSearchResultSection[] {
    let position = 0;
    return groups
        .filter((group) => RECORD_TYPES[group.type])
        .map((group) => {
            const recordType = RECORD_TYPES[group.type];
            return {
                labelKey: recordType.labelKey,
                rows: group.results.map((result) => {
                    const row = {
                        ...result,
                        route: recordType.routeTo(result),
                        position,
                        optionId: `${RESULTS_LIST_ID}-${position}`,
                    };
                    position++;
                    return row;
                }),
            };
        });
}

export function allRows(
    sections: GlobalSearchResultSection[],
): GlobalSearchResultRow[] {
    return sections.flatMap((section) => section.rows);
}
